// Ligado por padrão em builds de produção (staging e produção) e desligado em dev/testes;
// VITE_ANALYTICS_ENABLED ('true'/'false') só existe para sobrescrever esse padrão.
export function isAnalyticsEnabled(): boolean {
  const flag = import.meta.env.VITE_ANALYTICS_ENABLED
  if (flag === 'true') return true
  if (flag === 'false') return false
  return import.meta.env.PROD
}
